<template>
  <div class="cf-flex cf-flex--column cf-flex--gap-16 cf-padding-bottom-16">
    <h2 class="cf-title cf-title--2">
      Low Inventory
    </h2>

    <ul class="cf-flex cf-flex--column cf-flex--align-start cf-flex--gap-12 cf-bullet-list">
      <li
        v-for="item in items"
        :key="item.orderItemId"
        class="cf-flex cf-flex--columm cf-flex--gap-10"
      >
        <h4 class="cf-title cf-title--4">
          {{ item.itemDescription }}
        </h4>

        <p class="cf-subtitle cf-subtitle--2">
          There {{ item.inventoryCount > 1 ? 'are' : 'is' }}
          only <b class="cf-subtitle--heavy">{{ item.inventoryCount }}</b> left in stock.
        </p>
      </li>
    </ul>

    <p class="cf-subtitle cf-subtitle--2">
      Would you like to keep {{ items.length > 1 ? 'these items' : 'this item' }} with the
      {{ items.length > 1 ? 'quantities' : 'quantity' }} adjusted, or remove the
      {{ items.length > 1 ? 'items' : 'item' }} from your cart?
    </p>

    <button
      type="button"
      :class="[
        'cf-button cf-button--primary cf-button--lg cf-button--fill',
        { 'cf-button--loading': isRemoving }
      ]"
      @click="removeItemsExceedingInventory"
    >
      Remove
    </button>

    <button
      type="button"
      :class="[
        'cf-button cf-button--tertiary cf-button--lg cf-button--fill',
        { 'cf-button--loading': isUpdating }
      ]"
      @click="adjustItemsExceedingInventory"
    >
      Keep {{ items.length > 1 ? 'Items' : 'Item' }}
    </button>
  </div>
</template>


<script>
  export default {
    name: 'ItemsExceedingInventory',

    props: {
      items: {
        type: Array,
        required: true
      }
    },

    data() {
      return {
        isRemoving: false,
        isUpdating: false
      };
    },

    methods: {
      async adjustItemsExceedingInventory() {
        this.toggleLoading('isUpdating', true);

        await this.$store.dispatch('orders/editItems', {
          items: this.items.map(item => ({
            ...item,
            quantity: item.inventoryCount
          })),
          validate: false // don't revalidate so the user flow for
          // handling various invalid order items can be completed
        });

        this.toggleLoading('isUpdating', false);

        this.$closeModal('itemsExceedingInventory');
      },

      async removeItemsExceedingInventory() {
        this.toggleLoading('isRemoving', true);

        await this.$store.dispatch('orders/removeItems', {
          orderItemIds: this.items.map(item => item.orderItemId),
          validate: false // don't revalidate so the user flow for
          // handling various invalid order items can be completed
        });

        this.toggleLoading('isRemoving', false);

        this.$closeModal('itemsExceedingInventory');
      },

      toggleLoading(key, value) {
        this[key] = value;
      }
    }
  };
</script>

